import { Epic } from "redux-observable";
import { switchMap, filter } from "rxjs/operators";
import { Observable } from "rxjs";
import { IState, Dependencies } from "../@types";
import { RootAction } from "../actions";
import { isActionOf } from "typesafe-actions";
import { clientsActionsAsync } from "../actions/clientsActions";
import { Auth } from "aws-amplify";


export const editClientCountsEpic: Epic<
    RootAction,
    RootAction,
    IState,
    Dependencies
> = (action$, state$, dependencies) => {
    return action$.pipe(
        filter(isActionOf(clientsActionsAsync.editClientCounts.request)),
        switchMap(action => {
            return new Observable<RootAction>(observer => {
                const state = state$.value as IState;
                const { apiGatewayUrl, licenseApiKey } = state.constants;
                const { licence } = action.payload;
                async function editClientCounts() {
                    const session = await Auth.currentSession();
                    const token = session.getIdToken().getJwtToken();

                    const updatedCounts = await dependencies.licensesApi.addClientLicences({
                        apiGatewayUrl,
                        token,
                        licenseApiKey,
                        licence,
                    });
                    let formatted = updatedCounts;
                    observer.next(clientsActionsAsync.editClientCounts.success({ counts: formatted }));
                }
                editClientCounts().catch(error => {
                    console.log(error);
                    observer.next(clientsActionsAsync.editClientCounts.failure({ error }));
                });
            });
        })
    );
}